/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplyGroupContentDto } from '../../models/apply-group-content-dto';

export interface DeviceGroupControllerApplyContent$Params {
  id: string;
  clientWorkspaceId: string;
      body: ApplyGroupContentDto
}

export function deviceGroupControllerApplyContent(http: HttpClient, rootUrl: string, params: DeviceGroupControllerApplyContent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deviceGroupControllerApplyContent.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deviceGroupControllerApplyContent.PATH = '/api/device-group/{clientWorkspaceId}/{id}/content';
